module.exports = __webpack_public_path__ + "img/中国荔枝博物馆.83c82f3f.png";